import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'
import NotificationsSystem from 'reapop'
import theme from '@kenetto/reapop-theme-wybo'

import Menu from '../Menu/NewMenu'
import './Main.css'
import PatientsViewerContainer from './PatientsViewer/PatientsViewerContainer'
import SettingsContainer from './Settings/SettingsContainer'
import VaccinationPlanContainer from './Stats/VaccinationPlanContainer'
import SearchContainer from './Search/SearchContainer'
import ProfileContainer from './Profile/ProfileContainer'
import withPolyglot from '../common/withPolyglot'
import Administrative from './Administrative/Administrative'

const navigation = [
  {
    path: '/patients',
    exact: false,
    name: 'patients'
  },
  {
    path: '/plan',
    exact: false,
    name: 'vaccinationPlan'
  },
  {
    path: '/search',
    exact: false,
    name: 'search'
  },
  {
    path: '/administrativeInsertion',
    exact: false,
    name: 'administrativeInsertion'
  }
]

function getDoctorProfession (gender, profession) {
  if (gender === 'male') {
    switch (profession) {
      case 'doctor':
        return 'doctorMale'
      case 'nurse':
        return 'nurseMale'
      default:
        return 'noneMale'
    }
  } else if (gender === 'female') {
    switch (profession) {
      case 'doctor':
        return 'doctorFemale'
      case 'nurse':
        return 'nurseFemale'
      default:
        return 'noneFemale'
    }
  } else {
    switch (profession) {
      case 'doctor':
        return 'doctorUniversal'
      case 'nurse':
        return 'nurseUniversal'
      default:
        return 'noneUniversal'
    }
  }
}

const Main = props => {
  const {doctorProfile, match, translate} = props
  const { url } = match
  return (
    <Fragment>
      <div className='navigation-container'>
        <Menu main={navigation} right={{
          name: `${translate(getDoctorProfession(doctorProfile.gender, doctorProfile.profession))} ${doctorProfile.name}`,
          icon: doctorProfile.photo,
          items: [
            {
              path: '/settings',
              exact: false,
              name: 'settings'
            },
            {
              path: '/profile',
              exact: false,
              name: 'profile'
            },
            {
              name: 'logout',
              path: '/',
              exact: true,
              onClick: () => props.logout()
            }
          ]}} />
      </div>
      <div className='main-container uk-container uk-container-large'>
        <NotificationsSystem theme={theme} />
        <div className='box box-main uk-container-large'>
          <Switch>
            <Route
              path={`${url}patients`}
              render={props => (
                <PatientsViewerContainer
                  {...props}
                />
              )}
            />
            <Route
              path={`${url}plan`}
              render={props => <VaccinationPlanContainer {...props} />} />
            <Route
              path={`${url}search`}
              render={props => <SearchContainer {...props} charThreshold={2} />}
            />
            <Route
              path={`${url}administrativeInsertion`}
              render={props => <Administrative {...props} />}
            />
            <Route path={`${url}settings`} render={props => <SettingsContainer {...props} />} />
            <Route path={`${url}profile`} render={props => <ProfileContainer {...props} />} />
          </Switch>
        </div>
      </div>
    </Fragment>

  )
}

export default withPolyglot(Main, 'main')
